document.addEventListener('DOMContentLoaded', () => {
    const catalogue = document.querySelector('[data-catalogue]');
    if (!catalogue) return;

    const exportButton = catalogue.querySelector(
        '[data-catalogue-export]'
    );

    const loadingOverlay = catalogue.querySelector('[data-catalogue-loading]');
    const loadingText = catalogue.querySelector('[data-catalogue-loading-text]');

    const setCatalogueLoading = (
        isLoading,
        message = 'Preparing catalogue...'
    ) => {
        catalogue.classList.toggle(
            'is-indexing',
            isLoading
        );

        catalogue.setAttribute(
            'aria-busy',
            isLoading ? 'true' : 'false'
        );

        if (loadingOverlay) {
            loadingOverlay.hidden = !isLoading;
        }

        if (loadingText && message) {
            loadingText.textContent = message;
        }

        if (searchToggle) {
            searchToggle.disabled = isLoading;
        }

        if (isLoading && searchInput) {
            searchInput.disabled = true;
        }
    };

    const track = catalogue.querySelector('[data-catalogue-track]');
    const firstButton = catalogue.querySelector('[data-catalogue-first]');
    const prevButton = catalogue.querySelector('[data-catalogue-prev]');
    const nextButton = catalogue.querySelector('[data-catalogue-next]');
    const lastButton = catalogue.querySelector('[data-catalogue-last]');
    const status = catalogue.querySelector('[data-catalogue-status]');
    const pagination = catalogue.querySelector('[data-catalogue-pagination]');
    const pageJumpInput = catalogue.querySelector('[data-catalogue-page-jump-input]');
    const pageJumpButton = catalogue.querySelector('[data-catalogue-page-jump-button]');

    const sidePrevButton = catalogue.querySelector('[data-catalogue-side-prev]');
    const sideNextButton = catalogue.querySelector('[data-catalogue-side-next]');

    const hasCover =
        catalogue.dataset.hasCover === 'true';

    const useFlipbookSections =
        catalogue.dataset.useFlipbookSections === 'true';

    const totalCataloguePages =
        Number(catalogue.dataset.totalCataloguePages) || 1;

    const modal = document.querySelector('[data-catalogue-modal]');
    const modalOverlay = document.querySelector('[data-catalogue-modal-overlay]');
    const modalContent = document.querySelector('[data-catalogue-modal-content]');
    const modalClose = document.querySelector('[data-catalogue-modal-close]');

    const searchInput = catalogue.querySelector('[data-catalogue-search-input]');
    const searchResults = catalogue.querySelector('[data-catalogue-search-results]');
    const searchStatus = catalogue.querySelector('[data-catalogue-search-status]');

    const searchPanel = catalogue.querySelector('[data-catalogue-search]');
    const searchToggle = catalogue.querySelector('[data-catalogue-search-toggle]');
    const searchClose = catalogue.querySelector('[data-catalogue-search-close]');

    let lastCatalogueCartSignature = '';
    let lastCatalogueCartCardCount = -1;
    let catalogueCartRequest = null;

    const getCatalogueCartSize = (item) => {
        const sizeOption =
            item.options?.find((option) =>
                String(option.group || '')
                    .toLowerCase()
                    .includes('size')
            );

        if (sizeOption?.value) {
            return String(sizeOption.value);
        }

        return '';
    };

    const normaliseCatalogueExternalId = (value) => {
        return String(value || '')
            .trim()
            .split('/')
            .filter(Boolean)
            .pop() || '';
    };

    const updateCatalogueCartCards = (cart) => {
        const cartItems = Array.isArray(cart.items)
            ? cart.items
            : [];

        catalogue
            .querySelectorAll('[data-catalogue-product]')
            .forEach((card) => {
                const productSkus =
                    String(
                        card.dataset.productVariantSkus || ''
                    )
                        .split('||')
                        .map((sku) => sku.trim())
                        .filter(Boolean);

                const productId =
                    normaliseCatalogueExternalId(
                        card.dataset.sparklayerProductId
                    );

                const matchingItems =
                    cartItems.filter((item) => {
                        if (
                            item.type &&
                            item.type !== 'PRODUCT'
                        ) {
                            return false;
                        }

                        const itemSku =
                            String(item.sku || '').trim();

                        const skuMatches =
                            itemSku &&
                            productSkus.includes(itemSku);

                        /*
                         * Fall back to SparkLayer's parent product
                         * ID only when the catalogue product has no
                         * variant SKUs.
                         */
                        const parentProductMatches =
                            productSkus.length === 0 &&
                            productId &&
                            normaliseCatalogueExternalId(
                                item.parentExternalId
                            ) === productId;

                        return (
                            skuMatches ||
                            parentProductMatches
                        );
                    });

                card.classList.toggle(
                    'is-in-cart',
                    matchingItems.length > 0
                );

                let tooltip = card.querySelector(
                    '[data-catalogue-cart-tooltip]'
                );

                if (!matchingItems.length) {
                    tooltip?.remove();
                    return;
                }

                if (!tooltip) {
                    tooltip = document.createElement('span');
                    tooltip.className =
                        'catalogue-card__cart-tooltip';
                    tooltip.dataset.catalogueCartTooltip = '';
                    tooltip.setAttribute('aria-hidden', 'true');

                    card.appendChild(tooltip);
                }

                tooltip.textContent = matchingItems
                    .map((item) => {
                        const size =
                            getCatalogueCartSize(item);

                        return [
                            size ? `${size}` : null,
                            `${item.quantity}`
                        ]
                            .filter(Boolean)
                            .join(' · ');
                    })
                    .join('\n');
            });
    };

    const refreshCatalogueCartState = async () => {
        if (catalogueCartRequest) {
            return catalogueCartRequest;
        }

        catalogueCartRequest = (async () => {
            try {
                const spark = await waitForSparkLayer();

                if (!spark?.getCart) {
                    throw new Error(
                        'SparkLayer cart is unavailable'
                    );
                }

                const cart = await spark.getCart();
                const cardCount = catalogue.querySelectorAll(
                    '[data-catalogue-product]'
                ).length;

                const cartSignature = JSON.stringify(
                    (cart?.items || []).map((item) => [
                        item.itemKey,
                        item.quantity,
                        item.sku
                    ])
                );

                if (
                    cartSignature ===
                        lastCatalogueCartSignature &&
                    cardCount ===
                        lastCatalogueCartCardCount
                ) {
                    return;
                }

                lastCatalogueCartSignature =
                    cartSignature;
                lastCatalogueCartCardCount = cardCount;

                updateCatalogueCartCards(cart || {});
            } catch (error) {
                console.error(
                    'SparkLayer catalogue cart state ' +
                        'could not be loaded:',
                    error
                );
            } finally {
                catalogueCartRequest = null;
            }
        })();

        return catalogueCartRequest;
    };

    const tableOfContents = catalogue.querySelector('[data-catalogue-toc]');
    const tableOfContentsLinks = Array.from(
        catalogue.querySelectorAll(
            '[data-catalogue-toc-link]'
        )
    );
    const tableOfContentsSections = Array.from(
        catalogue.querySelectorAll(
            '[data-catalogue-toc-section]'
        )
    );
    const tableOfContentsPagePanels = Array.from(
        catalogue.querySelectorAll(
            '[data-catalogue-toc-pages]'
        )
    );

    const openSearchDrawer = () => {
        if (!searchPanel) return;

        searchPanel.classList.add('is-open');
        searchPanel.setAttribute('aria-hidden', 'false');

        searchToggle?.setAttribute(
            'aria-expanded',
            'true'
        );

        window.setTimeout(() => {
            searchInput?.focus();
        }, 250);
    };

    const closeSearchDrawer = () => {
        if (!searchPanel) return;

        searchPanel.classList.remove('is-open');
        searchPanel.setAttribute('aria-hidden', 'true');

        searchToggle?.setAttribute(
            'aria-expanded',
            'false'
        );

        searchToggle?.focus();
    };

    searchToggle?.addEventListener(
        'click',
        () => {
            if (searchPanel?.classList.contains('is-open')) {
                closeSearchDrawer();
            } else {
                openSearchDrawer();
            }
        }
    );

    searchClose?.addEventListener(
        'click',
        closeSearchDrawer
    );

    document.addEventListener('keydown', (event) => {
        if (
            event.key === 'Escape' &&
            searchPanel?.classList.contains('is-open') &&
            !modal?.classList.contains('is-open')
        ) {
            event.preventDefault();
            closeSearchDrawer();
        }
    });

    const viewport = catalogue.querySelector('[data-catalogue-viewport]');
    const pageFlipBook = catalogue.querySelector('[data-catalogue-pageflip-book]');

    const pageFlipEnabled =
        catalogue.dataset.pageFlipEnabled === 'true';

    const sectionId =
        catalogue.dataset.sectionId || '';

    const sourcesElement = catalogue.querySelector(
        '[data-catalogue-sources]'
    );

    let catalogueSources = [];

    try {
        catalogueSources = JSON.parse(
            sourcesElement?.textContent || '[]'
        );
    } catch (error) {
        console.error(
            'Catalogue sources could not be parsed:',
            error
        );
    }

    const updateInitialSectionLabels = () => {
        const showSectionLabels =
            catalogueSources.length > 1;

        track
            ?.querySelectorAll(
                '[data-catalogue-section-label]'
            )
            .forEach((label) => {
                label.hidden = !showSectionLabels;
            });
    };

    catalogueSources = catalogueSources
        .map((source, sourceIndex) => ({
            sourceIndex,
            handle: String(source.handle || ''),
            title: String(source.title || ''),
            description: String(source.description || ''),
            imageUrl: String(source.imageUrl || ''),
            textColour: String(source.textColour || '').trim(),
            url: String(source.url || window.location.pathname),

            productCount: Number(source.productCount) || 0,

            shopifyPages: Math.max(
                Number(source.shopifyPages) || 1,
                1
            ),

            printedPages: Math.max(
                Number(source.printedPages) || 0,
                0
            ),

            coverPage: Math.max(
                Number(source.coverPage) || 1,
                1
            ),

            firstPrintedPage: Math.max(
                Number(source.firstPrintedPage) || 1,
                1
            ),

            needsBlankPage: source.needsBlankPage === true,

            blankPage: Number(source.blankPage) || 0
        }))
        .filter((source) => source.handle);

    if (!catalogueSources.length) {
        catalogueSources = [{
            sourceIndex: 0,
            handle: '',
            title: '',
            url: window.location.pathname,
            productCount: 0,
            shopifyPages: 1,
            printedPages: totalCataloguePages - (hasCover ? 1 : 0),
            firstPrintedPage: hasCover ? 2 : 1
        }];
    }

    let pageFlip = null;
    let pendingSearchHighlightHandle = null;

    if (!track || !prevButton || !nextButton) return;

    let slides = Array.from(track.querySelectorAll('[data-catalogue-slide]'));
    let currentIndex = slides.findIndex((slide) =>
        slide.classList.contains('is-active')
    );

    let productIndex = [];
    let isBuildingSearchIndex = false;

    const initialFirstPageExists = Boolean(
        track.querySelector(
            '[data-catalogue-slide]' +
            '[data-catalogue-source-index="0"]' +
            '[data-shopify-page="1"]'
        )
    );

    const loadedPages = new Set(
        initialFirstPageExists ? ['0:1'] : []
    );
    const pageRequests = new Map();

    if (currentIndex < 0) {
        currentIndex = 0;
    }

    const refreshSlides = () => {
        slides = Array.from(track.querySelectorAll('[data-catalogue-slide]'));
    };

    const syncCatalogueMeasurements = () => {
        /*
         * When PageFlip is active, use its calculated page height.
         * The original catalogue track is visually hidden and should
         * no longer be used for measurements.
         */
        if (
            catalogue.classList.contains('is-pageflip-active') &&
            pageFlip
        ) {
            const bounds = pageFlip.getBoundsRect();
            const pageHeight = bounds?.height || 0;
            const bookWidth = bounds?.width || 0;

            if (bookWidth > 0) {
                catalogue.style.setProperty(
                    '--catalogue-rendered-book-width',
                    `${Math.ceil(bookWidth)}px`
                );
            }

            if (pageHeight > 0) {
                catalogue.style.setProperty(
                    '--catalogue-page-height',
                    `${Math.ceil(pageHeight)}px`
                );
            }

            return;
        }

        refreshSlides();

        const activeSlide = slides[currentIndex];

        if (!activeSlide) return;

        const activePage =
            activeSlide.querySelector('.catalogue__page') ||
            activeSlide.querySelector('.catalogue__cover');

        if (!activePage) return;

        const pageHeight = activePage.offsetHeight;

        if (pageHeight <= 0) return;

        catalogue.style.setProperty(
            '--catalogue-page-height',
            `${Math.round(pageHeight)}px`
        );
    };

    const escapeHtml = (value = '') => {
        const element = document.createElement('div');
        element.textContent = value;
        return element.innerHTML;
    };

    const getPageKey = (
        sourceIndex,
        pageNumber
    ) => {
        return `${sourceIndex}:${pageNumber}`;
    };

    const getSource = (sourceIndex) => {
        return catalogueSources[sourceIndex] || null;
    };

    const updateTableOfContents = (currentPageIndex) => {
        if (
            !pageFlipBook ||
            !tableOfContentsLinks.length ||
            !Number.isInteger(currentPageIndex)
        ) {
            return;
        }

        const pageElements = Array.from(
            pageFlipBook.querySelectorAll(
                '.catalogue__pageflip-page'
            )
        );

        let activeSourceIndex = null;

        tableOfContentsLinks.forEach((link) => {
            const sourceIndex = Number(
                link.dataset.catalogueSourceIndex
            );

            if (!Number.isInteger(sourceIndex)) {
                return;
            }

            const sectionCoverIndex =
                pageElements.findIndex((page) => {
                    return (
                        page.hasAttribute(
                            'data-catalogue-section-cover'
                        ) &&
                        Number(
                            page.dataset.catalogueSourceIndex
                        ) === sourceIndex
                    );
                });

            if (
                sectionCoverIndex >= 0 &&
                sectionCoverIndex <= currentPageIndex
            ) {
                activeSourceIndex = sourceIndex;
            }
        });

        tableOfContentsLinks.forEach((link) => {
            const sourceIndex = Number(
                link.dataset.catalogueSourceIndex
            );

            const isActive =
                Number.isInteger(sourceIndex) &&
                sourceIndex === activeSourceIndex;

            link.classList.toggle(
                'is-active',
                isActive
            );

            if (isActive) {
                link.setAttribute(
                    'aria-current',
                    'page'
                );
            } else {
                link.removeAttribute(
                    'aria-current'
                );
            }
        });
    };

    const getPageUrl = (
        sourceIndex,
        pageNumber
    ) => {
        const source = getSource(sourceIndex);

        if (
            !source ||
            pageNumber < 1 ||
            pageNumber > source.shopifyPages
        ) {
            return null;
        }

        const url = new URL(
            source.url,
            window.location.origin
        );

        /*
         * Request only this section from the chosen collection.
         * The browser's visible URL is never changed.
         */
        if (sectionId) {
            url.searchParams.set(
                'section_id',
                sectionId
            );
        }

        url.searchParams.set(
            'page',
            String(pageNumber)
        );

        return url.href;
    };

    const getSourcePageStart = (source) => {
        return source?.firstPrintedPage || 1;
    };

    const getSlideSourceIndex = (slide) => {
        const sourceIndex = Number(
            slide?.dataset.catalogueSourceIndex
        );

        return Number.isInteger(sourceIndex) ?
            sourceIndex :
            0;
    };

    const getSlideShopifyPage = (slide) => {
        const pageNumber = Number(
            slide?.dataset.shopifyPage
        );

        return Number.isInteger(pageNumber) ?
            pageNumber :
            1;
    };

    const findSlideIndex = (
        sourceIndex,
        pageNumber
    ) => {
        refreshSlides();

        return slides.findIndex((slide) => {
            return (
                getSlideSourceIndex(slide) === sourceIndex &&
                getSlideShopifyPage(slide) === pageNumber
            );
        });
    };

    const getNextSourcePage = (
        sourceIndex,
        pageNumber
    ) => {
        const source = getSource(sourceIndex);

        if (!source) return null;

        if (pageNumber < source.shopifyPages) {
            return {
                sourceIndex,
                pageNumber: pageNumber + 1
            };
        }

        const nextSourceIndex = sourceIndex + 1;
        const nextSource = getSource(nextSourceIndex);

        if (!nextSource) return null;

        return {
            sourceIndex: nextSourceIndex,
            pageNumber: 1
        };
    };

    const getPreviousSourcePage = (
        sourceIndex,
        pageNumber
    ) => {
        if (pageNumber > 1) {
            return {
                sourceIndex,
                pageNumber: pageNumber - 1
            };
        }

        const previousSourceIndex = sourceIndex - 1;
        const previousSource = getSource(
            previousSourceIndex
        );

        if (!previousSource) return null;

        return {
            sourceIndex: previousSourceIndex,
            pageNumber: previousSource.shopifyPages
        };
    };

    const getLastSourcePage = () => {
        const sourceIndex =
            catalogueSources.length - 1;

        const source = getSource(sourceIndex);

        if (!source) {
            return {
                sourceIndex: 0,
                pageNumber: 1
            };
        }

        return {
            sourceIndex,
            pageNumber: source.shopifyPages
        };
    };

    const getLastLoadedSourcePage = () => {
        refreshSlides();

        const productSlides = slides.filter(
            (slide) =>
            slide.hasAttribute(
                'data-shopify-page'
            )
        );

        const lastSlide =
            productSlides[productSlides.length - 1];

        if (!lastSlide) {
            return {
                sourceIndex: 0,
                pageNumber: 1
            };
        }

        return {
            sourceIndex: getSlideSourceIndex(lastSlide),
            pageNumber: getSlideShopifyPage(lastSlide)
        };
    };

    const getSourcePrintedPage = (
        source,
        pageNumber,
        sideOffset = 0
    ) => {
        if (!source) return null;

        return (
            getSourcePageStart(source) +
            ((pageNumber - 1) * 2) +
            sideOffset
        );
    };

    const updateFetchedSlidePageNumbers = (
        slide,
        sourceIndex,
        pageNumber
    ) => {
        const source = getSource(sourceIndex);

        if (!slide || !source) return;

        const pages = Array.from(
            slide.querySelectorAll(
                '[data-catalogue-page]'
            )
        );

        pages.forEach((page, sideIndex) => {
            const printedPage =
                getSourcePrintedPage(
                    source,
                    pageNumber,
                    sideIndex
                );

            page.dataset.pageNumber =
                String(printedPage);

            const pageNumberElement =
                page.querySelector(
                    '[data-catalogue-page-number]'
                );

            if (pageNumberElement) {
                pageNumberElement.dataset.cataloguePageNumber =
                    String(printedPage);

                pageNumberElement.textContent =
                    `Page ${printedPage}`;
            }

            const sectionLabel =
                page.querySelector(
                    '[data-catalogue-section-label]'
                );

            if (sectionLabel) {
                sectionLabel.textContent =
                    source.title;

                sectionLabel.hidden =
                    catalogueSources.length <= 1;
            }
        });
    };

    const appendShopifyPage = async (
        sourceIndex,
        pageNumber
    ) => {


        const pageKey = getPageKey(
            sourceIndex,
            pageNumber
        );

        if (loadedPages.has(pageKey)) {
            return true;
        }

        if (pageRequests.has(pageKey)) {
            return pageRequests.get(pageKey);
        }

        const source = getSource(sourceIndex);
        const pageUrl = getPageUrl(
            sourceIndex,
            pageNumber
        );

        if (!source || !pageUrl) {
            return false;
        }

        const request = (async () => {
            try {
                const response = await fetch(pageUrl, {
                    credentials: 'same-origin'
                });

                if (!response.ok) {
                    throw new Error(
                        `Catalogue source ${sourceIndex}, ` +
                        `page ${pageNumber} returned ` +
                        `${response.status}`
                    );
                }

                const html = await response.text();

                const doc = new DOMParser().parseFromString(
                    html,
                    'text/html'
                );

                const fetchedTrack = doc.querySelector(
                    '[data-catalogue-track]'
                );

                const newSlide = fetchedTrack?.querySelector(
                    '[data-catalogue-slide]' +
                    `[data-shopify-page="${pageNumber}"]`
                ) || fetchedTrack?.querySelector(
                    '[data-catalogue-slide]:last-child'
                );

                if (!newSlide) {
                    throw new Error(
                        `Catalogue slide was not found for ` +
                        `${source.title}, page ${pageNumber}`
                    );
                }

                newSlide.classList.remove('is-active');

                newSlide.dataset.catalogueSourceIndex =
                    String(sourceIndex);

                newSlide.dataset.catalogueSourceHandle =
                    source.handle;

                newSlide.dataset.catalogueSectionTitle =
                    source.title;

                newSlide.dataset.shopifyPage =
                    String(pageNumber);

                updateFetchedSlidePageNumbers(
                    newSlide,
                    sourceIndex,
                    pageNumber
                );

                const duplicate = track.querySelector(
                    `[data-catalogue-slide]` +
                    `[data-catalogue-source-index="${sourceIndex}"]` +
                    `[data-shopify-page="${pageNumber}"]`
                );

                if (!duplicate) {
                    track.appendChild(newSlide);

                    loadCatalogueSparkLayerPrices(
                        newSlide
                    );
                }

                loadedPages.add(pageKey);
                refreshSlides();

                if (pageFlip) {
                    refreshPageFlipPages();
                }

                return true;
            } catch (error) {
                console.error(
                    'Catalogue page load failed:',
                    error
                );

                return false;
            } finally {
                pageRequests.delete(pageKey);
            }
        })();

        pageRequests.set(pageKey, request);

        return request;
    };

    const ensureSourcePageLoaded = async (
        targetSourceIndex,
        targetPage
    ) => {
        if (
            targetSourceIndex < 0 ||
            targetSourceIndex >= catalogueSources.length
        ) {
            return false;
        }

        /*
         * Load all earlier collections first so the slides
         * remain in the same order as the metafield list.
         */
        for (
            let sourceIndex = 0; sourceIndex <= targetSourceIndex; sourceIndex += 1
        ) {
            const source = getSource(sourceIndex);

            if (!source) return false;

            const finalPage =
                sourceIndex === targetSourceIndex ?
                targetPage :
                source.shopifyPages;

            for (
                let pageNumber = 1; pageNumber <= finalPage; pageNumber += 1
            ) {
                const pageKey = getPageKey(
                    sourceIndex,
                    pageNumber
                );

                const existingSlide = track.querySelector(
                    '[data-catalogue-slide]' +
                    `[data-catalogue-source-index="${sourceIndex}"]` +
                    `[data-shopify-page="${pageNumber}"]`
                );

                if (existingSlide) {
                    loadedPages.add(pageKey);
                    continue;
                }

                const loaded = await appendShopifyPage(
                    sourceIndex,
                    pageNumber
                );

                if (!loaded) {
                    return false;
                }
            }
        }

        refreshSlides();

        return true;
    };

    const preloadNextPage = () => {
        const lastLoaded =
            getLastLoadedSourcePage();

        const nextSourcePage =
            getNextSourcePage(
                lastLoaded.sourceIndex,
                lastLoaded.pageNumber
            );

        if (!nextSourcePage) {
            return;
        }

        appendShopifyPage(
            nextSourcePage.sourceIndex,
            nextSourcePage.pageNumber
        ).then((loaded) => {
            if (!loaded) return;

            rebuildProductIndex();

            if (searchInput?.value) {
                renderSearchResults(
                    searchInput.value
                );
            }

            if (pageFlip) {
                updatePageFlipUi();
            } else {
                update();
            }
        });
    };

    const getSlidePageNumbers = (slide) => {
        if (!slide) return [];

        return Array.from(
                slide.querySelectorAll('[data-catalogue-page-number]')
            )
            .map((pageNumber) =>
                Number(pageNumber.dataset.cataloguePageNumber)
            )
            .filter((pageNumber) =>
                Number.isInteger(pageNumber)
            );
    };

    const updatePageFlipUi = () => {
        if (!pageFlip) return;

        const currentPageIndex =
            pageFlip.getCurrentPageIndex();

        const pageCount =
            pageFlip.getPageCount();

        const pageCollection =
            pageFlip.getPageCollection();

        const currentSpreadIndex =
            pageCollection.getCurrentSpreadIndex();

        const totalSpreads =
            pageCollection.getSpread().length;

        const isAtStart =
            currentSpreadIndex <= 0;

        const isAtEnd =
            currentSpreadIndex >= totalSpreads - 1;

        prevButton.disabled = isAtStart;
        nextButton.disabled = isAtEnd;

        if (sidePrevButton) {
            sidePrevButton.disabled = isAtStart;
        }

        if (sideNextButton) {
            sideNextButton.disabled = isAtEnd;
        }

        if (firstButton) {
            firstButton.disabled = isAtStart;
        }

        if (lastButton) {
            lastButton.disabled = isAtEnd;
        }

        const printedPage =
            currentPageIndex + 1;

        updateTableOfContents(currentPageIndex);

        const isCover =
            hasCover && currentPageIndex === 0;

        if (status) {
            if (isCover) {
                status.textContent =
                    `Front cover · ${totalCataloguePages} pages`;
            } else if (
                pageFlip.getOrientation() === 'landscape' &&
                printedPage < totalCataloguePages
            ) {
                status.textContent =
                    `Pages ${printedPage}–${printedPage + 1} ` +
                    `of ${totalCataloguePages}`;
            } else {
                status.textContent =
                    `Page ${printedPage} of ${totalCataloguePages}`;
            }
        }

        if (
            pageJumpInput &&
            document.activeElement !== pageJumpInput
        ) {
            pageJumpInput.value =
                String(printedPage);
        }

        syncCatalogueMeasurements();
    };

    const update = () => {
        refreshSlides();

        if (currentIndex > slides.length - 1) {
            currentIndex = Math.max(slides.length - 1, 0);
        }

        slides.forEach((slide, index) => {
            slide.classList.toggle('is-active', index === currentIndex);
        });

        const hasLoadedNextSlide =
            currentIndex < slides.length - 1;

        const activeSlide = slides[currentIndex];

        const activeSourceIndex =
            getSlideSourceIndex(activeSlide);

        const activeShopifyPage =
            getSlideShopifyPage(activeSlide);

        const hasAnotherSourcePage = Boolean(
            getNextSourcePage(
                activeSourceIndex,
                activeShopifyPage
            )
        );

        const isAtStart =
            currentIndex === 0;

        const isAtEnd = !hasLoadedNextSlide &&
            !hasAnotherSourcePage;

        prevButton.disabled = isAtStart;
        nextButton.disabled = isAtEnd;

        if (sidePrevButton) {
            sidePrevButton.disabled = isAtStart;
        }

        if (sideNextButton) {
            sideNextButton.disabled = isAtEnd;
        }

        if (firstButton) {
            firstButton.disabled = isAtStart;
        }

        if (lastButton) {
            lastButton.disabled = isAtEnd;
        }

        const pageNumbers = getSlidePageNumbers(
            activeSlide
        );

        const isCover = activeSlide?.hasAttribute(
            'data-catalogue-cover'
        );

        const activePrintedPage = isCover ?
            1 :
            pageNumbers[0];

        if (Number.isInteger(activePrintedPage)) {
            updateTableOfContents(activePrintedPage);
        }

        if (status) {
            if (isCover) {
                status.textContent =
                    `Front cover · ${totalCataloguePages} pages`;
            } else if (pageNumbers.length === 2) {
                status.textContent =
                    `Pages ${pageNumbers[0]}–${pageNumbers[1]} ` +
                    `of ${totalCataloguePages}`;
            } else if (pageNumbers.length === 1) {
                status.textContent =
                    `Page ${pageNumbers[0]} of ${totalCataloguePages}`;
            } else {
                status.textContent = 'Catalogue';
            }
        }

        if (
            pageJumpInput &&
            document.activeElement !== pageJumpInput
        ) {
            if (isCover) {
                pageJumpInput.value = '1';
            } else if (pageNumbers.length) {
                pageJumpInput.value = String(
                    pageNumbers[0]
                );
            }
        }

        if (!catalogue.style.getPropertyValue('--catalogue-page-height')) {
            window.requestAnimationFrame(syncCatalogueMeasurements);
        }
    };

    prevButton.addEventListener('click', () => {
        if (pageFlip) {
            pageFlip.flipPrev();
            return;
        }

        if (currentIndex <= 0) return;

        currentIndex -= 1;
        update();
        preloadNextPage();
    });

    nextButton.addEventListener(
        'click',
        async () => {
            if (pageFlip) {
                pageFlip.flipNext();
                return;
            }

            refreshSlides();

            if (currentIndex < slides.length - 1) {
                currentIndex += 1;
                update();
                preloadNextPage();
                return;
            }

            const activeSlide =
                slides[currentIndex];

            const currentSourceIndex =
                getSlideSourceIndex(activeSlide);

            const currentShopifyPage =
                getSlideShopifyPage(activeSlide);

            const nextSourcePage =
                getNextSourcePage(
                    currentSourceIndex,
                    currentShopifyPage
                );

            if (!nextSourcePage) {
                update();
                return;
            }

            const originalText =
                nextButton.textContent;

            nextButton.disabled = true;
            nextButton.textContent = 'Loading...';

            const loaded =
                await appendShopifyPage(
                    nextSourcePage.sourceIndex,
                    nextSourcePage.pageNumber
                );

            refreshSlides();

            if (loaded) {
                const targetIndex =
                    findSlideIndex(
                        nextSourcePage.sourceIndex,
                        nextSourcePage.pageNumber
                    );

                if (targetIndex >= 0) {
                    currentIndex = targetIndex;
                }
            }

            nextButton.textContent =
                originalText || 'Next';

            rebuildProductIndex();
            update();
            preloadNextPage();
        }
    );

    sidePrevButton?.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();

        if (!prevButton.disabled) {
            prevButton.click();
        }
    });

    sideNextButton?.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();

        if (!nextButton.disabled) {
            nextButton.click();
        }
    });

    const jumpToCataloguePage = async (
        requestedPage
    ) => {
        if (
            !Number.isInteger(requestedPage) ||
            requestedPage < 1 ||
            requestedPage > totalCataloguePages
        ) {
            if (pageJumpInput) {
                pageJumpInput.value = String(
                    Math.min(
                        Math.max(requestedPage || 1, 1),
                        totalCataloguePages
                    )
                );
            }

            return;
        }

        if (pageFlip) {
            if (
                requestedPage > pageFlip.getPageCount()
            ) {
                return;
            }

            pageFlip.turnToPage(
                requestedPage - 1
            );

            updatePageFlipUi();
            return;
        }

        /*
         * Page 1 is the front cover when enabled.
         */
        if (
            requestedPage === 1 &&
            hasCover
        ) {
            refreshSlides();

            const coverIndex = slides.findIndex(
                (slide) =>
                slide.hasAttribute(
                    'data-catalogue-cover'
                )
            );

            if (coverIndex >= 0) {
                currentIndex = coverIndex;
                update();
            }

            return;
        }

        const sourceIndex =
            catalogueSources.findIndex((source) => {
                const sectionStart =
                    source.firstPrintedPage;

                const sectionEnd =
                    sectionStart +
                    (source.shopifyPages * 2) -
                    1;

                return (
                    requestedPage >= sectionStart &&
                    requestedPage <= sectionEnd
                );
            });

        const safeSourceIndex =
            sourceIndex >= 0 ?
            sourceIndex :
            catalogueSources.length - 1;

        const source =
            getSource(safeSourceIndex);

        if (!source) {
            return;
        }

        const pageOffset =
            requestedPage -
            source.firstPrintedPage;

        const targetShopifyPage =
            Math.floor(pageOffset / 2) + 1;

        const controls = [
            firstButton,
            prevButton,
            nextButton,
            lastButton,
            sidePrevButton,
            sideNextButton,
            pageJumpInput,
            pageJumpButton
        ].filter(Boolean);

        controls.forEach((control) => {
            control.disabled = true;
        });

        const loaded =
            await ensureSourcePageLoaded(
                safeSourceIndex,
                targetShopifyPage
            );

        controls.forEach((control) => {
            control.disabled = false;
        });

        if (!loaded) {
            update();
            return;
        }

        const targetSlideIndex =
            findSlideIndex(
                safeSourceIndex,
                targetShopifyPage
            );

        if (targetSlideIndex < 0) {
            update();
            return;
        }

        currentIndex = targetSlideIndex;

        rebuildProductIndex();
        update();
        preloadNextPage();
    };

    const tocResponsiveMedia = window.matchMedia(
        '(max-width: 1350px)'
    );

    const getTableOfContentsPanel = (link) => {
        if (!link) return null;

        const panelId = link.getAttribute(
            'aria-controls'
        );

        return panelId ?
            document.getElementById(panelId) :
            null;
    };

    const resetTableOfContentsPanelStyles = (panel) => {
        if (!panel) return;

        panel.classList.remove(
            'catalogue-toc__pages--portal'
        );

        panel.style.removeProperty('top');
        panel.style.removeProperty('left');
        panel.style.removeProperty('right');
        panel.style.removeProperty('width');
        panel.style.removeProperty('max-height');
    };

    const restoreTableOfContentsPanel = (
        link,
        panel
    ) => {
        if (!link || !panel) return;

        const section = link.closest(
            '[data-catalogue-toc-section]'
        );

        if (
            section &&
            panel.parentElement !== section
        ) {
            section.appendChild(panel);
        }

        resetTableOfContentsPanelStyles(panel);
    };

    const positionResponsiveTableOfContentsPanel = (
        link,
        panel
    ) => {
        if (!link || !panel) return;

        if (!tocResponsiveMedia.matches) {
            restoreTableOfContentsPanel(
                link,
                panel
            );
            return;
        }

        if (panel.parentElement !== document.body) {
            document.body.appendChild(panel);
        }

        panel.classList.add(
            'catalogue-toc__pages--portal'
        );

        const linkRect =
            link.getBoundingClientRect();

        const viewportPadding = 16;
        const panelGap = 8;

        const panelWidth = Math.min(
            360,
            window.innerWidth -
            (viewportPadding * 2)
        );

        let viewportLeft = linkRect.left;

        if (
            viewportLeft + panelWidth >
            window.innerWidth - viewportPadding
        ) {
            viewportLeft =
                window.innerWidth -
                panelWidth -
                viewportPadding;
        }

        viewportLeft = Math.max(
            viewportPadding,
            viewportLeft
        );

        const viewportTop =
            linkRect.bottom + panelGap;

        const availableHeight = Math.max(
            180,
            Math.min(
                620,
                window.innerHeight -
                viewportTop -
                viewportPadding
            )
        );

        panel.style.left =
            `${Math.round(
                viewportLeft + window.scrollX
            )}px`;

        panel.style.top =
            `${Math.round(
                viewportTop + window.scrollY
            )}px`;

        panel.style.width =
            `${Math.round(panelWidth)}px`;

        panel.style.maxHeight =
            `${Math.round(availableHeight)}px`;
    };

    const closeTableOfContentsSection = (
        section
    ) => {
        if (!section) return;

        const link = section.querySelector(
            '[data-catalogue-toc-link]'
        );

        const panel =
            getTableOfContentsPanel(link);

        link?.setAttribute(
            'aria-expanded',
            'false'
        );

        if (panel) {
            panel.hidden = true;
            restoreTableOfContentsPanel(
                link,
                panel
            );
        }

        section.classList.remove(
            'is-expanded'
        );
    };

    tableOfContents?.addEventListener(
        'click',
        (event) => {
            const link = event.target.closest(
                '[data-catalogue-toc-link]'
            );

            if (!link) return;

            event.preventDefault();
            event.stopPropagation();

            const section = link.closest(
                '[data-catalogue-toc-section]'
            );

            const panel =
                getTableOfContentsPanel(link);

            const sourceIndex = Number(
                link.dataset.catalogueSourceIndex
            );

            if (
                !section ||
                !panel ||
                !Number.isInteger(sourceIndex)
            ) {
                return;
            }

            const isAlreadyOpen =
                link.getAttribute(
                    'aria-expanded'
                ) === 'true';

            tableOfContentsSections.forEach(
                closeTableOfContentsSection
            );

            if (isAlreadyOpen) {
                return;
            }

            link.setAttribute(
                'aria-expanded',
                'true'
            );

            section.classList.add(
                'is-expanded'
            );

            panel.hidden = false;

            window.requestAnimationFrame(() => {
                positionResponsiveTableOfContentsPanel(
                    link,
                    panel
                );
            });

            if (pageFlip && pageFlipBook) {
                const pageElements = Array.from(
                    pageFlipBook.querySelectorAll(
                        '.catalogue__pageflip-page'
                    )
                );

                const sectionCoverIndex =
                    pageElements.findIndex((page) => {
                        return (
                            page.hasAttribute(
                                'data-catalogue-section-cover'
                            ) &&
                            Number(
                                page.dataset.catalogueSourceIndex
                            ) === sourceIndex
                        );
                    });

                if (sectionCoverIndex < 0) {
                    console.warn(
                        'Catalogue section cover was not found:',
                        sourceIndex
                    );
                    return;
                }

                pageFlip.turnToPage(
                    sectionCoverIndex
                );

                updatePageFlipUi();
                return;
            }

            const source = getSource(sourceIndex);

            if (!source) return;

            jumpToCataloguePage(
                source.coverPage
            );
        }
    );

    document.addEventListener(
        'click',
        (event) => {
            const thumbnail = event.target.closest(
                '[data-catalogue-toc-thumbnail]'
            );

            if (!thumbnail) return;

            event.preventDefault();
            event.stopPropagation();

            const pageIndex = Number(
                thumbnail.dataset.catalogueTocThumbnail
            );

            if (
                !pageFlip ||
                !Number.isInteger(pageIndex) ||
                pageIndex < 0 ||
                pageIndex >= pageFlip.getPageCount()
            ) {
                return;
            }

            pageFlip.turnToPage(pageIndex);

            updatePageFlipUi();

            document
                .querySelectorAll(
                    '.catalogue-toc__thumbnail.is-current'
                )
                .forEach((item) => {
                    item.classList.remove(
                        'is-current'
                    );
                });

            thumbnail.classList.add(
                'is-current'
            );
        }
    );

    const submitPageJump = () => {
        if (!pageJumpInput) return;

        const requestedPage = Number(
            pageJumpInput.value
        );

        jumpToCataloguePage(requestedPage);
    };

    pageJumpButton?.addEventListener(
        'click',
        submitPageJump
    );

    pageJumpInput?.addEventListener(
        'keydown',
        (event) => {
            if (event.key !== 'Enter') return;

            event.preventDefault();
            submitPageJump();
        }
    );

    firstButton?.addEventListener(
        'click',
        () => {
            if (pageFlip) {
                pageFlip.turnToPage(0);
                updatePageFlipUi();
                return;
            }

            jumpToCataloguePage(1);
        }
    );

    lastButton?.addEventListener(
        'click',
        async () => {
            if (pageFlip) {
                pageFlip.turnToPage(
                    pageFlip.getPageCount() - 1
                );

                updatePageFlipUi();
                return;
            }

            const lastSourcePage =
                getLastSourcePage();

            const loaded =
                await ensureSourcePageLoaded(
                    lastSourcePage.sourceIndex,
                    lastSourcePage.pageNumber
                );

            if (!loaded) {
                update();
                return;
            }

            const targetIndex =
                findSlideIndex(
                    lastSourcePage.sourceIndex,
                    lastSourcePage.pageNumber
                );

            if (targetIndex >= 0) {
                currentIndex = targetIndex;
            }

            rebuildProductIndex();
            update();
        }
    );

    const openModal = async (handle) => {
        if (
            !handle ||
            !modal ||
            !modalOverlay ||
            !modalContent
        ) {
            return;
        }

        const scrollbarWidth =
            window.innerWidth - document.documentElement.clientWidth;

        document.documentElement.style.setProperty(
            '--scrollbar-width',
            `${scrollbarWidth}px`
        );

        document.body.classList.add('catalogue-modal-open');
        modal.classList.add('is-open');
        modalOverlay.classList.add('is-open');

        modalContent.innerHTML =
            '<div class="loading">Loading product...</div>';

        try {
            const response = await fetch(
                `/products/${encodeURIComponent(handle)}`, {
                    credentials: 'same-origin'
                }
            );

            if (!response.ok) {
                throw new Error('Product not found');
            }

            const html = await response.text();
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const productRow = doc.querySelector('.product.row');

            if (!productRow) {
                throw new Error('Product content was not found');
            }

            modalContent.innerHTML = productRow.outerHTML;

            const fullProductLink = document.createElement('a');
            fullProductLink.href =
                `/products/${encodeURIComponent(handle)}`;
            fullProductLink.textContent = 'See full product';
            fullProductLink.className = 'full-product-link';

            modalContent.appendChild(fullProductLink);

            initialiseQuickViewGallery();
            initialiseQuickViewAccordions();
        } catch (error) {
            console.error('Catalogue quick view failed:', error);

            modalContent.innerHTML =
                '<div class="error">' +
                'This product is currently not available.' +
                '</div>';
        }
    };

    pageFlipBook?.addEventListener(
        'click',
        (event) => {
            const tile = event.target.closest(
                '[data-catalogue-next-section]'
            );

            if (!tile) {
                return;
            }

            event.preventDefault();
            event.stopImmediatePropagation();

            const targetSourceIndex = Number(
                tile.dataset.catalogueNextSection
            );

            if (
                !pageFlip ||
                !Number.isInteger(targetSourceIndex)
            ) {
                return;
            }

            const pageElements = Array.from(
                pageFlipBook.querySelectorAll(
                    '.catalogue__pageflip-page'
                )
            );

            const sectionCoverIndex =
                pageElements.findIndex((page) => {
                    return (
                        page.hasAttribute(
                            'data-catalogue-section-cover'
                        ) &&
                        Number(
                            page.dataset.catalogueSourceIndex
                        ) === targetSourceIndex
                    );
                });

            if (sectionCoverIndex < 0) {
                return;
            }

            pageFlip.turnToPage(
                sectionCoverIndex
            );

            updatePageFlipUi();
        },
        true
    );

    if (pageFlipBook) {
        const stopPageFlipProductGesture = (event) => {
            const productCard = event.target.closest(
                '[data-catalogue-product]'
            );

            if (!productCard) return;

            event.stopImmediatePropagation();
        };

        pageFlipBook.addEventListener(
            'pointerdown',
            stopPageFlipProductGesture,
            true
        );

        pageFlipBook.addEventListener(
            'mousedown',
            stopPageFlipProductGesture,
            true
        );

        pageFlipBook.addEventListener(
            'touchstart',
            stopPageFlipProductGesture, {
                capture: true,
                passive: true
            }
        );

        pageFlipBook.addEventListener(
            'click',
            (event) => {
                const productCard = event.target.closest(
                    '[data-catalogue-product]'
                );

                if (!productCard) return;

                event.preventDefault();
                event.stopImmediatePropagation();

                openModal(
                    productCard.dataset.productHandle
                );
            },
            true
        );
    }

    const closeModal = () => {
        document.body.classList.remove('catalogue-modal-open');

        document.documentElement.style.removeProperty(
            '--scrollbar-width'
        );

        modal?.classList.remove('is-open');
        modalOverlay?.classList.remove('is-open');

        if (modalContent) {
            modalContent.innerHTML = '';
        }
    };

    document.addEventListener('click', (event) => {
        const trigger = event.target.closest(
            '[data-catalogue-product]'
        );

        if (!trigger) return;

        event.preventDefault();

        openModal(trigger.dataset.productHandle);
    });

    modalOverlay?.addEventListener('click', closeModal);
    modalClose?.addEventListener('click', closeModal);

    document.addEventListener('keydown', (event) => {
        if (modal?.classList.contains('is-open')) {
            if (event.key === 'Escape') {
                closeModal();
            }

            return;
        }

        /*
         * Do not turn pages while the customer is typing in search.
         */
        if (
            event.target instanceof HTMLInputElement ||
            event.target instanceof HTMLTextAreaElement
        ) {
            return;
        }

        if (
            event.key === 'ArrowLeft' ||
            event.key === 'PageUp'
        ) {
            event.preventDefault();
            prevButton.click();
        }

        if (
            event.key === 'ArrowRight' ||
            event.key === 'PageDown'
        ) {
            event.preventDefault();
            nextButton.click();
        }

        if (event.key === 'Home') {
            event.preventDefault();
            firstButton?.click();
        }

        if (event.key === 'End') {
            event.preventDefault();
            lastButton?.click();
        }
    });

    const initialiseQuickViewGallery = () => {
        if (typeof Swiper === 'undefined' || !modal) return;

        const mainSliders = modal.querySelectorAll('.js-media-list');
        const subSliders = modal.querySelectorAll('.js-media-sublist');
        const thumbs = [];

        subSliders.forEach((slider, index) => {
            if (slider.swiper) return;

            thumbs[index] = new Swiper(slider, {
                slidesPerView: 4,
                spaceBetween: 10,
                watchSlidesProgress: true
            });
        });

        mainSliders.forEach((slider, index) => {
            if (slider.swiper) return;

            new Swiper(slider, {
                slidesPerView: 1,
                autoHeight: true,
                thumbs: {
                    swiper: thumbs[index] || null
                }
            });
        });
    };

    const initialiseQuickViewAccordions = () => {
        if (!modal) return;

        const accordions = modal.querySelectorAll(
            '.info-dropdown.js-info-dropdown'
        );

        accordions.forEach((accordion) => {
            const header = accordion.querySelector(
                '.info-dropdown__header, .accordion__button'
            );

            const content = accordion.querySelector(
                '.info-dropdown__content, .accordion__content'
            );

            if (!header || !content) return;

            header.addEventListener('click', (event) => {
                event.preventDefault();

                const isOpen = accordion.classList.toggle('is-open');

                header.setAttribute(
                    'aria-expanded',
                    isOpen ? 'true' : 'false'
                );

                if (isOpen) {
                    content.removeAttribute('hidden');
                    content.classList.add('open');
                    content.classList.remove('closed');
                } else {
                    content.setAttribute('hidden', '');
                    content.classList.remove('open');
                    content.classList.add('closed');
                }
            });
        });
    };

    const getProductPageLabel = (product) => {
        const cataloguePage = product.closest('.catalogue__page');

        const pageNumber = cataloguePage?.querySelector(
            '.catalogue__page-number'
        );

        return pageNumber?.textContent.trim() || 'Catalogue';
    };

    const getProductPageIndex = (product) => {
        const cataloguePage = product.closest(
            '[data-catalogue-page]'
        );

        const printedPage = Number(
            cataloguePage?.dataset.pageNumber
        );

        if (!Number.isInteger(printedPage)) {
            return null;
        }

        /*
         * Printed pages are numbered from 1.
         * StPageFlip indexes pages from 0.
         */
        return printedPage - 1;
    };

    const addSlideProductsToIndex = (slide, slideIndex) => {
        const products = slide.querySelectorAll(
            '[data-catalogue-product]'
        );

        products.forEach((product) => {
            const handle = product.dataset.productHandle || '';

            if (!handle) return;

            if (
                productIndex.some(
                    (indexedProduct) => indexedProduct.handle === handle
                )
            ) {
                return;
            }

            const variantSkus = (
                    product.dataset.productVariantSkus || ''
                )
                .split('||')
                .map((sku) => sku.trim())
                .filter(Boolean);

            productIndex.push({
                title: product.dataset.productTitle || '',
                sku: product.dataset.productSku || '',
                includes: product.dataset.productIncludes || '',
                variantOptions:
                    product.dataset.productVariantOptions || '',
                licence: product.dataset.productLicence || '',
                imageUrl: product.dataset.productImageUrl || '',
                parentProductId:
                    product.dataset.sparklayerProductId || '',
                sectionTitle:
                    slide.dataset.catalogueSectionTitle ||
                    catalogueSources[
                        getSlideSourceIndex(slide)
                    ]?.title ||
                    '',
                variantSkus,
                handle,
                slideIndex,
                pageIndex: getProductPageIndex(product),
                pageLabel: getProductPageLabel(product)
            });
        });
    };


    const catalogueSparkProductRequests = new Map();

    const waitForSparkLayer = async (
        timeout = 10000
    ) => {
        if (
            window.spark &&
            window.rubiesSparkLayer?.ready
        ) {
            return window.spark;
        }

        return new Promise((resolve) => {
            let finished = false;

            const complete = (spark = null) => {
                if (finished) return;

                finished = true;

                window.clearTimeout(timeoutId);

                window.removeEventListener(
                    'rubies-sparklayer-ready',
                    handleReady
                );

                resolve(spark);
            };

            const handleReady = () => {
                if (
                    window.spark &&
                    window.rubiesSparkLayer?.ready
                ) {
                    complete(window.spark);
                }
            };

            const timeoutId = window.setTimeout(() => {
                complete(null);
            }, timeout);

            window.addEventListener(
                'rubies-sparklayer-ready',
                handleReady, {
                    once: true
                }
            );

            handleReady();
        });
    };

    const formatCataloguePrice = (
        value,
        currencyCode = 'gbp'
    ) => {
        const numericValue = Number(value);

        if (!Number.isFinite(numericValue)) {
            return '';
        }

        return new Intl.NumberFormat('en-GB', {
            style: 'currency',
            currency: String(
                currencyCode || 'gbp'
            ).toUpperCase()
        }).format(numericValue);
    };

    const getCatalogueSparkProduct = async (
        parentProductId
    ) => {
        const productId = String(
            parentProductId || ''
        ).trim();

        if (!productId) {
            return null;
        }

        if (
            catalogueSparkProductRequests.has(
                productId
            )
        ) {
            return catalogueSparkProductRequests.get(
                productId
            );
        }

        const request = (async () => {
            const spark = await waitForSparkLayer();

            if (!spark) {
                throw new Error(
                    'SparkLayer did not become ready'
                );
            }

            return spark.getProduct(productId);
        })();

        catalogueSparkProductRequests.set(
            productId,
            request
        );

        try {
            return await request;
        } catch (error) {
            catalogueSparkProductRequests.delete(
                productId
            );

            throw error;
        }
    };

    const getCatalogueProductPrice = (
        product
    ) => {
        const variants = Array.isArray(
                product?.variants
            ) ?
            product.variants : [];

        const pricedVariants = variants.filter(
            (variant) => {
                return (
                    Number.isFinite(
                        Number(variant.price?.net)
                    ) &&
                    Number(variant.price.net) > 0
                );
            }
        );

        if (!pricedVariants.length) {
            return null;
        }

        const lowestPrice = Math.min(
            ...pricedVariants.map(
                (variant) =>
                Number(variant.price.net)
            )
        );

        const currencyCode =
            pricedVariants.find(
                (variant) =>
                variant.price?.currencyCode
            )?.price?.currencyCode || 'gbp';

        const hasDifferentPrices =
            pricedVariants.some(
                (variant) =>
                Number(variant.price.net) !==
                lowestPrice
            );

        return {
            value: lowestPrice,
            currencyCode,
            showFrom: hasDifferentPrices
        };
    };

    const loadCatalogueSparkLayerPrice = async (
        productCard
    ) => {
        if (!productCard) return;

        const parentProductId =
            productCard.dataset.sparklayerProductId;

        const priceElement =
            productCard.querySelector(
                '[data-catalogue-sparklayer-price]'
            );

        if (
            !parentProductId ||
            !priceElement ||
            priceElement.dataset.priceLoaded ===
            'true'
        ) {
            return;
        }

        priceElement.dataset.priceLoading =
            'true';

        try {
            const product =
                await getCatalogueSparkProduct(
                    parentProductId
                );

            const priceData =
                getCatalogueProductPrice(product);

            if (!priceData) {
                priceElement.textContent =
                    'Price unavailable';

                return;
            }

            const formattedPrice =
                formatCataloguePrice(
                    priceData.value,
                    priceData.currencyCode
                );

            priceElement.textContent =
                priceData.showFrom ?
                `From ${formattedPrice}` :
                formattedPrice;

            priceElement.dataset.priceLoaded =
                'true';
        } catch (error) {
            console.error(
                'Catalogue SparkLayer price failed:', {
                    parentProductId,
                    error
                }
            );

            priceElement.textContent =
                'Price unavailable';
        } finally {
            delete priceElement.dataset.priceLoading;
        }
    };

    const loadCatalogueSparkLayerPrices = async (
        root = document
    ) => {
        const productCards = Array.from(
            root.querySelectorAll(
                '[data-catalogue-product]' +
                '[data-sparklayer-product-id]'
            )
        );

        await Promise.allSettled(
            productCards.map(
                loadCatalogueSparkLayerPrice
            )
        );
    };

    const getSpreadsheetPrice = async (
        parentProductId
    ) => {
        try {
            const sparkProduct =
                await getCatalogueSparkProduct(
                    parentProductId
                );

            const priceData =
                getCatalogueProductPrice(
                    sparkProduct
                );

            if (!priceData) {
                return 'Price unavailable';
            }

            const formattedPrice =
                formatCataloguePrice(
                    priceData.value,
                    priceData.currencyCode
                );

            return priceData.showFrom
                ? `From ${formattedPrice}`
                : formattedPrice;
        } catch (error) {
            console.error(
                'Spreadsheet price failed:',
                {
                    parentProductId,
                    error
                }
            );

            return 'Price unavailable';
        }
    };

    const formatSpreadsheetIncludes = (
        value
    ) => {
        const includesValue =
            String(value || '').trim();

        if (!includesValue) {
            return '';
        }

        /*
        * Handles values such as:
        * ["Wig", "Specs", "Medallion", "Headband"]
        */
        try {
            const parsedValue =
                JSON.parse(includesValue);

            if (Array.isArray(parsedValue)) {
                return parsedValue
                    .map((item) =>
                        String(item || '').trim()
                    )
                    .filter(Boolean)
                    .join(', ');
            }
        } catch (error) {
            /*
            * Fall through to a simpler cleanup if the
            * metafield value isn't valid JSON.
            */
        }

        return includesValue
            .replace(/^\s*\[/, '')
            .replace(/\]\s*$/, '')
            .split(',')
            .map((item) =>
                item
                    .trim()
                    .replace(/^["']|["']$/g, '')
            )
            .filter(Boolean)
            .join(', ');
    };

    const spreadsheetBlobToDataUrl = (blob) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();

            reader.addEventListener(
                'load',
                () => resolve(reader.result)
            );

            reader.addEventListener(
                'error',
                () => reject(reader.error)
            );

            reader.readAsDataURL(blob);
        });
    };

    const loadSpreadsheetImage = async (imageUrl) => {
        if (!imageUrl) return null;

        try {
            const response = await fetch(imageUrl, {
                mode: 'cors',
                credentials: 'omit'
            });

            if (!response.ok) {
                throw new Error(
                    `Image request failed: ${response.status}`
                );
            }

            const sourceBlob = await response.blob();

            /*
             * Convert the Shopify image to a small PNG. This gives
             * ExcelJS a supported format and keeps the workbook size
             * under control while preserving the image proportions.
             */
            if (typeof window.createImageBitmap === 'function') {
                const bitmap =
                    await window.createImageBitmap(sourceBlob);

                const maximumDimension = 160;
                const scale = Math.min(
                    maximumDimension / bitmap.width,
                    maximumDimension / bitmap.height,
                    1
                );

                const width = Math.max(
                    Math.round(bitmap.width * scale),
                    1
                );

                const height = Math.max(
                    Math.round(bitmap.height * scale),
                    1
                );

                const canvas = document.createElement('canvas');
                canvas.width = width;
                canvas.height = height;

                const context = canvas.getContext('2d');

                if (!context) {
                    bitmap.close?.();
                    throw new Error('Canvas is unavailable');
                }

                context.drawImage(
                    bitmap,
                    0,
                    0,
                    width,
                    height
                );

                bitmap.close?.();

                const pngBlob = await new Promise(
                    (resolve, reject) => {
                        canvas.toBlob(
                            (blob) => {
                                if (blob) {
                                    resolve(blob);
                                } else {
                                    reject(
                                        new Error(
                                            'Image conversion failed'
                                        )
                                    );
                                }
                            },
                            'image/png'
                        );
                    }
                );

                return {
                    base64:
                        await spreadsheetBlobToDataUrl(
                            pngBlob
                        ),
                    extension: 'png',
                    width,
                    height
                };
            }

            const extensionByType = {
                'image/jpeg': 'jpeg',
                'image/jpg': 'jpeg',
                'image/png': 'png',
                'image/gif': 'gif'
            };

            const extension =
                extensionByType[sourceBlob.type];

            if (!extension) {
                throw new Error(
                    `Unsupported image type: ${sourceBlob.type}`
                );
            }

            return {
                base64:
                    await spreadsheetBlobToDataUrl(
                        sourceBlob
                    ),
                extension,
                width: 80,
                height: 80
            };
        } catch (error) {
            console.error(
                'Spreadsheet image failed:',
                {
                    imageUrl,
                    error
                }
            );

            return null;
        }
    };

    const loadSpreadsheetImages = async (
        imageUrls,
        onProgress
    ) => {
        const uniqueImageUrls = Array.from(
            new Set(imageUrls.filter(Boolean))
        );

        const images = new Map();

        if (!uniqueImageUrls.length) {
            return images;
        }

        let nextImageIndex = 0;
        let completedImages = 0;

        const worker = async () => {
            while (nextImageIndex < uniqueImageUrls.length) {
                const imageIndex = nextImageIndex;
                nextImageIndex += 1;

                const imageUrl = uniqueImageUrls[imageIndex];
                const image =
                    await loadSpreadsheetImage(imageUrl);

                if (image) {
                    images.set(imageUrl, image);
                }

                completedImages += 1;
                onProgress?.(
                    completedImages,
                    uniqueImageUrls.length
                );
            }
        };

        await Promise.all(
            Array.from(
                {
                    length: Math.min(
                        6,
                        uniqueImageUrls.length
                    )
                },
                () => worker()
            )
        );

        return images;
    };

    const downloadCatalogueSpreadsheet = async () => {
        if (!exportButton) return;

        if (!window.ExcelJS) {
            console.error(
                'The ExcelJS library is unavailable.'
            );

            return;
        }

        exportButton.disabled = true;

        const originalTitle =
            exportButton.title;

        exportButton.title =
            'Preparing spreadsheet…';

        try {
            /*
            * Rebuild immediately before export so the rows
            * follow the fully loaded catalogue track.
            */
            rebuildProductIndex();

            const productRows = await Promise.all(
                productIndex.map(async (product) => {
                    const price =
                        await getSpreadsheetPrice(
                            product.parentProductId
                        );

                    return {
                        sectionTitle:
                            product.sectionTitle,
                        imageUrl: product.imageUrl,
                        page: Number.isInteger(
                            product.pageIndex
                        )
                            ? product.pageIndex + 1
                            : '',
                        row: {
                            'Page': Number.isInteger(
                                product.pageIndex
                            )
                                ? product.pageIndex + 1
                                : '',
                            'Image': '',
                            imageUrl: product.imageUrl,
                            'Item Code': product.sku,
                            'Product Title':
                                product.title,
                            'Includes':
                                formatSpreadsheetIncludes(
                                    product.includes
                                ),
                            'Size/Colours':
                                product.variantOptions,
                            'Licence': product.licence,
                            'Price': price
                        }
                    };
                })
            );

            const rows = [];
            let currentSection = null;

            productRows.forEach((productRow) => {
                const sectionTitle =
                    productRow.sectionTitle ||
                    'Catalogue';

                if (sectionTitle !== currentSection) {
                    /*
                    * One blank row before the section heading.
                    */
                    rows.push({});

                    /*
                    * Section heading and its first product page.
                    */
                    rows.push({
                        'Page': productRow.page,
                        'Product Title': sectionTitle
                    });

                    /*
                    * One blank row after the section heading.
                    */
                    rows.push({});

                    currentSection = sectionTitle;
                }

                rows.push(productRow.row);
            });

            const workbook =
                new window.ExcelJS.Workbook();

            const spreadsheetImages =
                await loadSpreadsheetImages(
                    productRows.map(
                        (productRow) =>
                            productRow.imageUrl
                    ),
                    (complete, total) => {
                        exportButton.title =
                            `Preparing images ${complete}/${total}…`;
                    }
                );

            workbook.creator = 'Catalogue';
            workbook.created = new Date();

            const worksheet =
                workbook.addWorksheet(
                    'Catalogue',
                    {
                        views: [
                            {
                                state: 'frozen',
                                ySplit: 1
                            }
                        ]
                    }
                );

            worksheet.columns = [
                {
                    header: 'Page',
                    key: 'page',
                    width: 10
                },
                {
                    header: 'Image',
                    key: 'image',
                    width: 14
                },
                {
                    header: 'Item Code',
                    key: 'itemCode',
                    width: 18
                },
                {
                    header: 'Product Title',
                    key: 'productTitle',
                    width: 38
                },
                {
                    header: 'Includes',
                    key: 'includes',
                    width: 45
                },
                {
                    header: 'Size/Colours',
                    key: 'sizeColours',
                    width: 45
                },
                {
                    header: 'Licence',
                    key: 'licence',
                    width: 32
                },
                {
                    header: 'Price',
                    key: 'price',
                    width: 18
                }
            ];

            /*
            * Style the main column-heading row.
            */
            const headerRow = worksheet.getRow(1);

            headerRow.font = {
                bold: true
            };

            headerRow.eachCell(
                {
                    includeEmpty: true
                },
                (cell) => {
                    cell.border = {
                        bottom: {
                            style: 'thin',
                            color: {
                                argb: 'FF000000'
                            }
                        }
                    };
                }
            );

            /*
            * Add blank rows, section headings and products in the
            * order already prepared in the rows array.
            */
            rows.forEach((rowData) => {
                const isBlankRow =
                    Object.keys(rowData).length === 0;

                if (isBlankRow) {
                    worksheet.addRow([]);
                    return;
                }

                const isSectionRow =
                    Boolean(
                        rowData['Product Title']
                    ) &&
                    !Object.prototype.hasOwnProperty.call(
                        rowData,
                        'Item Code'
                    );

                const excelRow =
                    worksheet.addRow({
                        page: rowData['Page'] ?? '',
                        image: '',
                        itemCode:
                            rowData['Item Code'] ?? '',
                        productTitle:
                            rowData['Product Title'] ?? '',
                        includes:
                            rowData['Includes'] ?? '',
                        sizeColours:
                            rowData['Size/Colours'] ?? '',
                        licence:
                            rowData['Licence'] ?? '',
                        price:
                            rowData['Price'] ?? ''
                    });

                const spreadsheetImage =
                    spreadsheetImages.get(
                        rowData.imageUrl
                    );

                if (spreadsheetImage) {
                    excelRow.height = 64;

                    const imageId = workbook.addImage({
                        base64: spreadsheetImage.base64,
                        extension:
                            spreadsheetImage.extension
                    });

                    const imageScale = Math.min(
                        78 / spreadsheetImage.width,
                        78 / spreadsheetImage.height
                    );

                    const imageWidth =
                        spreadsheetImage.width *
                        imageScale;

                    const imageHeight =
                        spreadsheetImage.height *
                        imageScale;

                    const imageColumnWidth = 96;
                    const imageRowHeight = 85;

                    worksheet.addImage(imageId, {
                        tl: {
                            col:
                                1 +
                                Math.max(
                                    (imageColumnWidth -
                                        imageWidth) /
                                        imageColumnWidth /
                                        2,
                                    0.04
                                ),
                            row:
                                excelRow.number - 1 +
                                Math.max(
                                    (imageRowHeight -
                                        imageHeight) /
                                        imageRowHeight /
                                        2,
                                    0.04
                                )
                        },
                        ext: {
                            width: imageWidth,
                            height: imageHeight
                        },
                        editAs: 'oneCell'
                    });
                }

                if (isSectionRow) {
                    excelRow.font = {
                        bold: true
                    };

                    /*
                    * Apply the bottom border across all eight columns,
                    * including currently empty cells.
                    */
                    for (
                        let columnNumber = 1;
                        columnNumber <= 8;
                        columnNumber += 1
                    ) {
                        excelRow.getCell(
                            columnNumber
                        ).border = {
                            bottom: {
                                style: 'thin',
                                color: {
                                    argb: 'FF000000'
                                }
                            }
                        };
                    }
                }
            });

            /*
            * Keep filtering available across the exported area.
            */
            worksheet.autoFilter = {
                from: 'A1',
                to: `H${worksheet.rowCount}`
            };

            const catalogueTitle =
                catalogue.querySelector(
                    '.catalogue-site-header__title'
                )?.textContent?.trim() ||
                'Catalogue';

            const safeFilename =
                catalogueTitle
                    .replace(
                        /[<>:"/\\|?*\u0000-\u001F]/g,
                        '-'
                    )
                    .replace(/\s+/g, ' ')
                    .trim() ||
                'Catalogue';

            const workbookBuffer =
                await workbook.xlsx.writeBuffer();

            const workbookBlob =
                new Blob(
                    [workbookBuffer],
                    {
                        type:
                            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                    }
                );

            const downloadUrl =
                URL.createObjectURL(
                    workbookBlob
                );

            const downloadLink =
                document.createElement('a');

            downloadLink.href = downloadUrl;
            downloadLink.download =
                `${safeFilename}.xlsx`;

            document.body.appendChild(
                downloadLink
            );

            downloadLink.click();
            downloadLink.remove();

            window.setTimeout(() => {
                URL.revokeObjectURL(
                    downloadUrl
                );
            }, 1000);

            
        } finally {
            exportButton.disabled = false;
            exportButton.title = originalTitle;
        }
    };

    exportButton?.addEventListener(
        'click',
        downloadCatalogueSpreadsheet
    );


    const rebuildProductIndex = () => {
        refreshSlides();
        productIndex = [];

        slides.forEach((slide, slideIndex) => {
            addSlideProductsToIndex(slide, slideIndex);
        });
    };

    const renderSearchResults = (query) => {
        if (!searchResults) return;

        const searchTerm = query.trim().toLowerCase();

        if (!searchTerm) {
            searchResults.innerHTML = '';
            return;
        }

        const matches = productIndex
            .map((product) => {
                const matchingVariantSku = product.variantSkus.find(
                    (variantSku) =>
                    variantSku.toLowerCase().includes(searchTerm)
                );

                const matchesTitle = product.title
                    .toLowerCase()
                    .includes(searchTerm);

                const matchesStyleCode = product.sku
                    .toLowerCase()
                    .includes(searchTerm);

                if (
                    !matchesTitle &&
                    !matchesStyleCode &&
                    !matchingVariantSku
                ) {
                    return null;
                }

                return {
                    ...product,
                    matchingSku: matchingVariantSku || product.sku
                };
            })
            .filter(Boolean)
            .slice(0, 30);

        if (!matches.length) {
            searchResults.innerHTML =
                '<div class="catalogue-search__empty">' +
                'No products found' +
                '</div>';

            return;
        }

        searchResults.innerHTML = matches
            .map((product) => {
                const title = escapeHtml(product.title);
                const sku = escapeHtml(product.matchingSku);
                const pageLabel = escapeHtml(product.pageLabel);
                const handle = escapeHtml(product.handle);

                const meta = sku ?
                    `${sku} · ${pageLabel}` :
                    pageLabel;

                return `
          <button
            type="button"
            class="catalogue-search__result"
              data-catalogue-search-jump="${product.slideIndex}"
              data-catalogue-search-page="${product.pageIndex ?? ''}"
              data-catalogue-search-handle="${handle}"
          >
            <span class="catalogue-search__result-title">
              ${title}
            </span>

            <span class="catalogue-search__result-meta">
              ${meta}
            </span>
          </button>
        `;
            })
            .join('');
    };

    const enableSearch = () => {
        if (searchInput) {
            searchInput.disabled = false;
        }

        if (searchStatus) {
            searchStatus.textContent = `Search ready · ${productIndex.length} products indexed`;
            searchStatus.classList.add('is-ready');
        }
    };

    const buildFullSearchIndex = async () => {
        if (isBuildingSearchIndex) return;

        setCatalogueLoading(
            true,
            'Preparing catalogue...'
        );

        isBuildingSearchIndex = true;

        if (searchStatus) {
            searchStatus.textContent =
                'Search loading...';

            searchStatus.classList.remove(
                'is-ready'
            );
        }

        rebuildProductIndex();

        let completedPages = 1;

        const totalSourcePages =
            catalogueSources.reduce(
                (total, source) =>
                total + source.shopifyPages,
                0
            );

        for (
            let sourceIndex = 0; sourceIndex < catalogueSources.length; sourceIndex += 1
        ) {
            const source =
                getSource(sourceIndex);

            if (!source) continue;

            for (
                let pageNumber = 1; pageNumber <= source.shopifyPages; pageNumber += 1
            ) {

                const existingSlide = track.querySelector(
                    '[data-catalogue-slide]' +
                    `[data-catalogue-source-index="${sourceIndex}"]` +
                    `[data-shopify-page="${pageNumber}"]`
                );

                if (existingSlide) {
                    loadedPages.add(
                        getPageKey(sourceIndex, pageNumber)
                    );

                    continue;
                }

                await appendShopifyPage(
                    sourceIndex,
                    pageNumber
                );

                completedPages += 1;
                rebuildProductIndex();

                if (loadingText) {
                    loadingText.textContent =
                        `Preparing catalogue... ` +
                        `${productIndex.length} products indexed ` +
                        `(${completedPages} of ${totalSourcePages} pages)`;
                }
            }
        }

        enableSearch();
        isBuildingSearchIndex = false;

        if (exportButton) {
            exportButton.disabled = false;
        }

        if (searchInput?.value) {
            renderSearchResults(
                searchInput.value
            );
        }

        if (pageFlip) {
            refreshPageFlipPages();
            updatePageFlipUi();
        } else {
            update();
        }

        window.requestAnimationFrame(() => {
            window.requestAnimationFrame(() => {
                setCatalogueLoading(false);
            });
        });
    };

    searchInput?.addEventListener('input', () => {
        renderSearchResults(searchInput.value);
    });


    const clearSearchHighlights = () => {
        document
            .querySelectorAll(
                '.catalogue-card.is-search-highlighted'
            )
            .forEach((card) => {
                card.classList.remove(
                    'is-search-highlighted'
                );
            });
    };

    const highlightPageFlipProduct = (handle) => {
        if (!pageFlipBook || !handle) {
            return false;
        }

        clearSearchHighlights();

        const matchingCards = Array.from(
            pageFlipBook.querySelectorAll(
                `[data-catalogue-product][data-product-handle="${CSS.escape(handle)}"]`
            )
        );

        if (!matchingCards.length) {
            return false;
        }

        /*
         * Prefer the copy on the currently visible StPageFlip page.
         */
        const productCard =
            matchingCards.find((card) => {
                const page = card.closest(
                    '.stf__item, .catalogue__pageflip-page'
                );

                if (!page) return false;

                const styles =
                    window.getComputedStyle(page);

                return (
                    styles.display !== 'none' &&
                    styles.visibility !== 'hidden' &&
                    Number(styles.opacity || 1) > 0
                );
            }) || matchingCards[0];

        productCard.classList.add(
            'is-search-highlighted'
        );

        window.setTimeout(() => {
            productCard.classList.remove(
                'is-search-highlighted'
            );
        }, 5000);

        return true;
    };

    const getPageFlipProductPageIndex = (handle) => {
        if (!pageFlipBook || !handle) {
            return null;
        }

        const productCard = pageFlipBook.querySelector(
            `[data-catalogue-product]` +
            `[data-product-handle="${CSS.escape(handle)}"]`
        );

        if (!productCard) {
            return null;
        }

        const productPage = productCard.closest(
            '.catalogue__pageflip-page'
        );

        if (!productPage) {
            return null;
        }

        const pageElements = Array.from(
            pageFlipBook.querySelectorAll(
                '.catalogue__pageflip-page'
            )
        );

        const pageIndex = pageElements.indexOf(
            productPage
        );

        return pageIndex >= 0 ?
            pageIndex :
            null;
    };

    searchResults?.addEventListener(
        'click',
        (event) => {
            const result = event.target.closest(
                '[data-catalogue-search-jump]'
            );

            if (!result) return;

            const slideIndex = Number(
                result.dataset.catalogueSearchJump
            );

            const storedPageIndex = Number(
                result.dataset.catalogueSearchPage
            );

            const productHandle =
                result.dataset.catalogueSearchHandle;

            /*
             * PageFlip mode
             */
            if (pageFlip) {
                const actualPageIndex =
                    getPageFlipProductPageIndex(
                        productHandle
                    );

                const targetPageIndex =
                    Number.isInteger(actualPageIndex) ?
                    actualPageIndex :
                    storedPageIndex;

                if (
                    !Number.isInteger(targetPageIndex) ||
                    targetPageIndex < 0 ||
                    targetPageIndex >= pageFlip.getPageCount()
                ) {
                    console.warn(
                        'Search result page could not be found:',
                        productHandle
                    );

                    return;
                }

                pendingSearchHighlightHandle =
                    productHandle;

                pageFlip.turnToPage(
                    targetPageIndex
                );

                /*
                 * Allow StPageFlip to finish changing
                 * the visible spread before highlighting.
                 */
                window.setTimeout(() => {
                    const highlighted =
                        highlightPageFlipProduct(
                            productHandle
                        );

                    if (highlighted) {
                        pendingSearchHighlightHandle =
                            null;
                    }

                    updatePageFlipUi();
                }, 150);
            } else {
                /*
                 * Existing fallback mode
                 */
                currentIndex = slideIndex;
                update();

                clearSearchHighlights();

                const activeSlide =
                    slides[currentIndex];

                const productCard =
                    activeSlide?.querySelector(
                        `[data-catalogue-product]` +
                        `[data-product-handle="${CSS.escape(productHandle)}"]`
                    );

                if (productCard) {
                    productCard.classList.add(
                        'is-search-highlighted'
                    );

                    window.setTimeout(() => {
                        productCard.classList.remove(
                            'is-search-highlighted'
                        );
                    }, 5000);
                }
            }

            searchResults
                .querySelectorAll(
                    '.catalogue-search__result.is-selected'
                )
                .forEach((item) => {
                    item.classList.remove(
                        'is-selected'
                    );
                });

            result.classList.add(
                'is-selected'
            );
        }
    );

    const removeDuplicateIds = (element) => {
        if (element.id) {
            element.removeAttribute('id');
        }

        element.querySelectorAll('[id]').forEach((child) => {
            child.removeAttribute('id');
        });
    };

    const createSectionCoverPage = (source) => {
        const coverPage = document.createElement('div');

        coverPage.className =
            'catalogue__pageflip-page ' +
            'catalogue__pageflip-page--section-cover';

        coverPage.dataset.catalogueSectionCover = '';
        coverPage.dataset.catalogueSourceIndex =
            String(source.sourceIndex);
        coverPage.dataset.pageNumber =
            String(source.coverPage);

        if (source.imageUrl) {
            const image = document.createElement('img');

            image.className =
                'catalogue__section-cover-image';

            image.src = source.imageUrl;
            image.alt = source.title;
            image.loading = 'eager';
            image.decoding = 'async';

            coverPage.appendChild(image);
        } else {
            coverPage.classList.add(
                'catalogue__pageflip-page--section-cover-no-image'
            );
        }

        const content = document.createElement('div');

        content.className =
            'catalogue__section-cover-content';

        if (source.textColour) {
            content.style.setProperty(
                'color',
                source.textColour,
                'important'
            );
        }

        const title = document.createElement('h2');

        title.className =
            'catalogue__section-cover-title';

        title.textContent = source.title;

        content.appendChild(title);

        if (source.description.trim()) {
            const description =
                document.createElement('div');

            description.className =
                'catalogue__section-cover-description rte';

            description.innerHTML =
                source.description;

            content.appendChild(description);
        }

        coverPage.appendChild(content);

        return coverPage;
    };

    const createSectionBlankPage = (source) => {
        const blankPage = document.createElement('div');

        blankPage.className =
            'catalogue__pageflip-page ' +
            'catalogue__pageflip-page--right ' +
            'catalogue__pageflip-page--section-blank';

        blankPage.dataset.catalogueSectionBlank = '';
        blankPage.dataset.catalogueSourceIndex =
            String(source.sourceIndex);
        blankPage.dataset.pageNumber =
            String(source.blankPage);

        /*
         * Vertical collection title tab.
         */
        const sectionLabel =
            document.createElement('div');

        sectionLabel.className =
            'catalogue__section-label';

        sectionLabel.dataset.catalogueSectionLabel = '';
        sectionLabel.textContent = source.title;

        blankPage.appendChild(sectionLabel);

        /*
         * Page number footer.
         */
        const pageNumber =
            document.createElement('div');

        pageNumber.className =
            'catalogue__page-number';

        pageNumber.dataset.cataloguePageNumber =
            String(source.blankPage);

        pageNumber.textContent =
            `Page ${source.blankPage}`;

        blankPage.appendChild(pageNumber);

        return blankPage;
    };

    const createNextSectionTile = (
        nextSource,
        isBlankPage = false
    ) => {
        const tile = document.createElement('button');

        tile.type = 'button';

        tile.className =
            'catalogue-card ' +
            'catalogue-card--next-section';

        if (isBlankPage) {
            tile.classList.add(
                'catalogue-card--next-section-blank'
            );
        }

        tile.dataset.catalogueNextSection =
            String(nextSource.sourceIndex);

        tile.setAttribute(
            'aria-label',
            `Go to next section: ${nextSource.title}`
        );

        const eyebrow = document.createElement('span');

        eyebrow.className =
            'catalogue-card__next-section-eyebrow';

        eyebrow.textContent = 'Next section';

        const title = document.createElement('span');

        title.className =
            'catalogue-card__next-section-title';

        title.textContent = nextSource.title;

        const arrow = document.createElement('span');

        arrow.className =
            'catalogue-card__next-section-arrow';

        arrow.setAttribute('aria-hidden', 'true');
        arrow.textContent = '→';

        tile.append(
            eyebrow,
            title,
            arrow
        );

        return tile;
    };

    const getPageFlipClones = () => {
        if (!track) return [];

        const pageClones = [];

        /*
         * Preserve the main catalogue front cover.
         */
        if (hasCover) {
            const originalCover = track.querySelector(
                '[data-catalogue-cover] [data-catalogue-page]'
            );

            if (originalCover) {
                const coverClone =
                    originalCover.cloneNode(true);

                removeDuplicateIds(coverClone);

                coverClone.classList.add(
                    'catalogue__pageflip-page',
                    'catalogue__pageflip-page--main-cover'
                );

                coverClone.classList.remove(
                    'catalogue__cover'
                );

                coverClone.removeAttribute(
                    'data-catalogue-page'
                );

                coverClone
                    .querySelectorAll('img')
                    .forEach((image) => {
                        image.loading = 'eager';
                        image.decoding = 'async';

                        image.setAttribute(
                            'loading',
                            'eager'
                        );
                    });

                pageClones.push(coverClone);
            }
        }

        catalogueSources.forEach(
            (source, sourcePosition) => {
                /*
                 * Add this collection's section cover.
                 */
                pageClones.push(
                    createSectionCoverPage(source)
                );

                /*
                 * Keep references to this section's cloned
                 * product pages so the final one can be checked.
                 */
                const sectionProductPages = [];

                /*
                 * Find all loaded Shopify pagination slides
                 * belonging to this collection.
                 */
                const sourceSlides = Array.from(
                    track.querySelectorAll(
                        `[data-catalogue-slide]` +
                        `[data-catalogue-source-index="${source.sourceIndex}"]` +
                        `[data-shopify-page]`
                    )
                ).sort((firstSlide, secondSlide) => {
                    return (
                        getSlideShopifyPage(firstSlide) -
                        getSlideShopifyPage(secondSlide)
                    );
                });

                sourceSlides.forEach((slide) => {
                    const sourcePages = Array.from(
                        slide.querySelectorAll(
                            '[data-catalogue-page]'
                        )
                    );

                    sourcePages.forEach((sourcePage) => {
                        /*
                         * Do not include an automatically generated
                         * product page if it contains no products.
                         */
                        const hasProducts = Boolean(
                            sourcePage.querySelector(
                                '[data-catalogue-product]'
                            )
                        );

                        if (!hasProducts) {
                            return;
                        }

                        const clone =
                            sourcePage.cloneNode(true);

                        removeDuplicateIds(clone);

                        /*
                         * Check the original side before removing
                         * the Liquid page classes.
                         */
                        const isLeftPage =
                            sourcePage.classList.contains(
                                'catalogue__page--left'
                            );

                        const isRightPage =
                            sourcePage.classList.contains(
                                'catalogue__page--right'
                            );

                        clone.classList.add(
                            'catalogue__pageflip-page'
                        );

                        if (isLeftPage) {
                            clone.classList.add(
                                'catalogue__pageflip-page--right'
                            );
                        }

                        if (isRightPage) {
                            clone.classList.add(
                                'catalogue__pageflip-page--left'
                            );
                        }

                        clone.classList.remove(
                            'catalogue__page',
                            'catalogue__page--left',
                            'catalogue__page--right'
                        );

                        clone.removeAttribute(
                            'data-catalogue-page'
                        );

                        clone
                            .querySelectorAll('img')
                            .forEach((image) => {
                                image.loading = 'eager';
                                image.decoding = 'async';

                                image.setAttribute(
                                    'loading',
                                    'eager'
                                );
                            });

                        /*
                         * Preserve the existing page order.
                         */
                        pageClones.push(clone);
                        sectionProductPages.push(clone);
                    });
                });

                const nextSource =
                    catalogueSources[
                        sourcePosition + 1
                    ];

                /*
                 * The final section has no Next Section tile.
                 */
                if (!nextSource) {
                    if (source.needsBlankPage) {
                        pageClones.push(
                            createSectionBlankPage(source)
                        );
                    }

                    return;
                }

                /*
                 * When an intentional blank page exists,
                 * place the tile in its bottom-right position.
                 */
                if (source.needsBlankPage) {
                    const blankPage =
                        createSectionBlankPage(source);

                    blankPage.appendChild(
                        createNextSectionTile(
                            nextSource,
                            true
                        )
                    );

                    pageClones.push(blankPage);

                    return;
                }

                /*
                 * Otherwise inspect the final product page.
                 */
                const finalProductPage =
                    sectionProductPages[
                        sectionProductPages.length - 1
                    ];

                if (!finalProductPage) {
                    return;
                }

                const productCount =
                    finalProductPage.querySelectorAll(
                        '[data-catalogue-product]'
                    ).length;

                /*
                 * Add the tile when the final page contains
                 * between one and eight products.
                 */
                if (
                    productCount < 1 ||
                    productCount > 8
                ) {
                    return;
                }

                const productGrid =
                    finalProductPage.querySelector(
                        '.catalogue__grid'
                    );

                if (!productGrid) {
                    return;
                }

                productGrid.appendChild(
                    createNextSectionTile(nextSource)
                );
            }
        );

        return pageClones;
    };

    let tableOfContentsThumbnailSignature = '';

    const prepareTableOfContentsThumbnail = (
        sourcePage
    ) => {
        const thumbnailPage =
            sourcePage.cloneNode(true);

        removeDuplicateIds(thumbnailPage);

        /*
         * Remove StPageFlip classes and inline layout state
         * that hide inactive pages.
         */
        thumbnailPage.classList.remove(
            'stf__item',
            '--soft',
            '--hard',
            '--left',
            '--right'
        );

        thumbnailPage.classList.add(
            'catalogue-toc__thumbnail-page'
        );

        const thumbnailElements = [
            thumbnailPage,
            ...thumbnailPage.querySelectorAll('*')
        ];

        thumbnailElements.forEach((element) => {
            element.removeAttribute('style');
            element.removeAttribute('hidden');
            element.removeAttribute('inert');
            element.removeAttribute('aria-hidden');
        });

        /*
         * Use the URLs already loaded by the live catalogue.
         */
        const sourceImages = Array.from(
            sourcePage.querySelectorAll('img')
        );

        const thumbnailImages = Array.from(
            thumbnailPage.querySelectorAll('img')
        );

        thumbnailImages.forEach(
            (thumbnailImage, imageIndex) => {
                const sourceImage =
                    sourceImages[imageIndex];

                if (!sourceImage) return;

                const loadedImageUrl =
                    sourceImage.currentSrc ||
                    sourceImage.src;

                if (loadedImageUrl) {
                    thumbnailImage.src =
                        loadedImageUrl;
                }

                thumbnailImage.removeAttribute(
                    'srcset'
                );

                thumbnailImage.removeAttribute(
                    'sizes'
                );

                thumbnailImage.loading = 'eager';
                thumbnailImage.decoding = 'async';
            }
        );

        thumbnailPage
            .querySelectorAll(
                'button, input, select, textarea'
            )
            .forEach((control) => {
                control.tabIndex = -1;
            });

        thumbnailPage.setAttribute(
            'aria-hidden',
            'true'
        );

        return thumbnailPage;
    };

    const buildTableOfContentsThumbnails = () => {
        if (
            !pageFlipBook ||
            !tableOfContentsPagePanels.length
        ) {
            return;
        }

        const pageElements = Array.from(
            pageFlipBook.querySelectorAll(
                '.catalogue__pageflip-page'
            )
        );

        if (!pageElements.length) {
            return;
        }

        /*
         * Avoid rebuilding every thumbnail when PageFlip updates
         * without changing the page collection.
         */
        const signature = pageElements
            .map((page, pageIndex) => {
                return [
                    pageIndex,
                    page.dataset.catalogueSourceIndex || '',
                    page.dataset.pageNumber || '',
                    page.hasAttribute(
                        'data-catalogue-section-cover'
                    ) ?
                    'cover' :
                    '',
                    page.hasAttribute(
                        'data-catalogue-section-blank'
                    ) ?
                    'blank' :
                    ''
                ].join(':');
            })
            .join('|');

        if (
            signature === tableOfContentsThumbnailSignature
        ) {
            return;
        }

        tableOfContentsThumbnailSignature = signature;

        const pagesBySource = new Map();

        catalogueSources.forEach((source) => {
            pagesBySource.set(
                source.sourceIndex,
                []
            );
        });

        let currentSourceIndex = null;

        pageElements.forEach((page, pageIndex) => {
            /*
             * A section cover marks the beginning of a collection.
             */
            if (
                page.hasAttribute(
                    'data-catalogue-section-cover'
                )
            ) {
                const sourceIndex = Number(
                    page.dataset.catalogueSourceIndex
                );

                if (Number.isInteger(sourceIndex)) {
                    currentSourceIndex = sourceIndex;
                }
            }

            /*
             * The main front cover appears before any section.
             */
            if (!Number.isInteger(currentSourceIndex)) {
                return;
            }

            /*
             * Do not show intentionally inserted blank pages.
             */
            if (
                page.hasAttribute(
                    'data-catalogue-section-blank'
                )
            ) {
                return;
            }

            if (!pagesBySource.has(currentSourceIndex)) {
                pagesBySource.set(
                    currentSourceIndex,
                    []
                );
            }

            pagesBySource
                .get(currentSourceIndex)
                .push({
                    page,
                    pageIndex
                });
        });

        tableOfContentsPagePanels.forEach((panel) => {
            const sourceIndex = Number(
                panel.dataset.catalogueSourceIndex
            );

            const sectionPages =
                pagesBySource.get(sourceIndex) || [];

            panel.replaceChildren();

            if (!sectionPages.length) {
                const emptyMessage =
                    document.createElement('div');

                emptyMessage.className =
                    'catalogue-toc__pages-empty';

                emptyMessage.textContent =
                    'No pages available';

                panel.appendChild(emptyMessage);
                return;
            }

            sectionPages.forEach(({
                page,
                pageIndex
            }) => {
                const thumbnailButton =
                    document.createElement('button');

                thumbnailButton.type = 'button';

                thumbnailButton.className =
                    'catalogue-toc__thumbnail';

                thumbnailButton.dataset.catalogueTocThumbnail =
                    String(pageIndex);

                const printedPage = Number(
                    page.dataset.pageNumber
                );

                const pageLabel =
                    Number.isInteger(printedPage) ?
                    `Page ${printedPage}` :
                    `Page ${pageIndex + 1}`;

                thumbnailButton.setAttribute(
                    'aria-label',
                    `Go to ${pageLabel}`
                );

                const previewViewport =
                    document.createElement('span');

                previewViewport.className =
                    'catalogue-toc__thumbnail-viewport';

                const previewPage =
                    prepareTableOfContentsThumbnail(
                        page
                    );

                previewViewport.appendChild(
                    previewPage
                );

                const label =
                    document.createElement('span');

                label.className =
                    'catalogue-toc__thumbnail-label';

                label.textContent = pageLabel;

                thumbnailButton.append(
                    previewViewport,
                    label
                );

                panel.appendChild(
                    thumbnailButton
                );
            });
        });
    };

    const syncTableOfContentsPages = () => {
        if (
            !pageFlipBook ||
            !tableOfContentsLinks.length
        ) {
            return;
        }

        const pageElements = Array.from(
            pageFlipBook.querySelectorAll(
                '.catalogue__pageflip-page'
            )
        );

        tableOfContentsLinks.forEach((link) => {
            const sourceIndex = Number(
                link.dataset.catalogueSourceIndex
            );

            const sectionCoverIndex =
                pageElements.findIndex((page) => {
                    return (
                        page.hasAttribute(
                            'data-catalogue-section-cover'
                        ) &&
                        Number(
                            page.dataset.catalogueSourceIndex
                        ) === sourceIndex
                    );
                });

            const pageLabel = link.querySelector(
                '[data-catalogue-toc-page-label]'
            );

            if (!pageLabel) return;

            if (sectionCoverIndex >= 0) {
                pageLabel.textContent =
                    `Page ${sectionCoverIndex + 3}`;

                link.dataset.catalogueTocPageIndex =
                    String(sectionCoverIndex);
            } else {
                pageLabel.textContent = 'Page —';

                delete link.dataset.catalogueTocPageIndex;
            }
        });
    };

    const waitForPageFlipImages = async (pages) => {
        const images = pages.flatMap((page) =>
            Array.from(page.querySelectorAll('img'))
        );

        if (!images.length) {
            return;
        }

        await Promise.all(
            images.map(async (image) => {
                if (image.complete && image.naturalWidth > 0) {
                    try {
                        await image.decode();
                    } catch (error) {
                        // The image is already usable even if decode() rejects.
                    }

                    return;
                }

                await new Promise((resolve) => {
                    const finish = () => {
                        image.removeEventListener('load', finish);
                        image.removeEventListener('error', finish);
                        resolve();
                    };

                    image.addEventListener('load', finish);
                    image.addEventListener('error', finish);
                });

                try {
                    await image.decode();
                } catch (error) {
                    // Continue if the browser cannot explicitly decode the image.
                }
            })
        );
    };

    const refreshPageFlipPages = () => {
        if (!pageFlip || !pageFlipBook) return;

        const currentPageIndex =
            pageFlip.getCurrentPageIndex();

        const pageClones = getPageFlipClones();

        if (!pageClones.length) return;

        try {
            pageFlip.updateFromHtml(pageClones);

            loadCatalogueSparkLayerPrices(
                pageFlipBook
            );

            const safePageIndex = Math.min(
                currentPageIndex,
                pageFlip.getPageCount() - 1
            );

            pageFlip.turnToPage(safePageIndex);

            window.requestAnimationFrame(() => {
                pageFlip?.update();
                syncCatalogueMeasurements();
                syncTableOfContentsPages();
                buildTableOfContentsThumbnails();
                updatePageFlipUi();
            });
        } catch (error) {
            console.error(
                'StPageFlip page update failed:',
                error
            );
        }
    };

    const fitCatalogueBookToAvailableHeight = () => {
        const reader = catalogue.querySelector(
            '.catalogue__reader-layout'
        );

        const stage = catalogue.querySelector(
            '.catalogue__stage'
        );

        if (!reader || !stage) return;

        const getOuterHeight = (element) => {
            if (!element) return 0;

            const styles = window.getComputedStyle(element);

            return (
                element.offsetHeight +
                (parseFloat(styles.marginTop) || 0) +
                (parseFloat(styles.marginBottom) || 0)
            );
        };

        let availableHeight = reader.clientHeight;

        const contents = catalogue.querySelector(
            '.catalogue-toc'
        );

        /*
        * Below 1350px the contents panel sits above the book,
        * so its height must be removed from the available space.
        */
        if (
            contents &&
            window.getComputedStyle(contents).display !== 'none' &&
            window.getComputedStyle(reader).display !== 'grid'
        ) {
            availableHeight -= getOuterHeight(contents);
        }

        const stageStyles = window.getComputedStyle(stage);

        availableHeight -=
            (parseFloat(stageStyles.marginTop) || 0) +
            (parseFloat(stageStyles.marginBottom) || 0);

        availableHeight = Math.max(
            Math.floor(availableHeight),
            396
        );

        const availableWidth = stage.clientWidth;

        /*
        * One portrait page is 700:990.
        * A two-page spread is 1400:990.
        */
        const forceSinglePage =
            window.matchMedia('(max-width: 989px)').matches;

        const usePortrait =
            forceSinglePage ||
            availableWidth < availableHeight;

        const bookRatio = usePortrait
            ? 700 / 990
            : 1400 / 990;

        const fittedWidth = Math.floor(
            Math.min(
                availableWidth,
                availableHeight * bookRatio
            )
        );

        catalogue.style.setProperty(
            '--catalogue-book-max-width',
            `${fittedWidth}px`
        );

        catalogue.style.setProperty(
            '--catalogue-rendered-book-width',
            `${fittedWidth}px`
        );

        catalogue.style.setProperty(
            '--catalogue-available-book-height',
            `${availableHeight}px`
        );
    };

    const pageFlipAvailable =
        typeof window.St !== 'undefined' &&
        typeof window.St.PageFlip === 'function';

    const initialisePageFlipTest = async () => {
        if (
            !pageFlipEnabled ||
            !pageFlipAvailable ||
            !pageFlipBook ||
            pageFlip
        ) {
            return;
        }

        fitCatalogueBookToAvailableHeight();

        const pageClones = getPageFlipClones();

        loadCatalogueSparkLayerPrices(
            pageFlipBook
        );

        if (!pageClones.length) {
            console.warn(
                'StPageFlip could not initialise: no catalogue pages found.'
            );

            return;
        }

        await waitForPageFlipImages(pageClones);

        pageFlipBook.replaceChildren(...pageClones);

        try {
            pageFlip = new window.St.PageFlip(pageFlipBook, {
                width: 700,
                height: 990,

                size: 'stretch',

                minWidth: 280,
                maxWidth: 700,

                minHeight: 396,
                maxHeight: 990,

                showCover: hasCover,
                usePortrait: true,

                autoSize: true,

                drawShadow: true,
                maxShadowOpacity: 0.35,

                flippingTime: 700,

                mobileScrollSupport: false,
                clickEventForward: true,

                useMouseEvents: false,
                disableFlipByClick: true
            });

            pageFlip.on('flip', () => {
                updatePageFlipUi();

                if (pendingSearchHighlightHandle) {
                    const highlighted =
                        highlightPageFlipProduct(
                            pendingSearchHighlightHandle
                        );

                    if (highlighted) {
                        pendingSearchHighlightHandle = null;
                    }
                }
            });

            pageFlip.on('init', (event) => {
                catalogue.classList.add(
                    'is-pageflip-active'
                );

                pageFlipBook.setAttribute(
                    'aria-hidden',
                    'false'
                );

                window.requestAnimationFrame(() => {
                    pageFlip?.update();

                    window.requestAnimationFrame(() => {
                        syncCatalogueMeasurements();
                        syncTableOfContentsPages();
                        buildTableOfContentsThumbnails();
                        updatePageFlipUi();
                    });
                });

            });

            pageFlip.loadFromHTML(pageClones);
        } catch (error) {
            pageFlip = null;

            catalogue.classList.remove(
                'is-pageflip-active'
            );

            pageFlipBook.setAttribute(
                'aria-hidden',
                'true'
            );

            pageFlipBook.replaceChildren();

            console.error(
                'StPageFlip initialisation failed:',
                error
            );
        }
    };

    const repositionOpenTableOfContentsPanel = () => {
        const openLink =
            tableOfContents?.querySelector(
                '[data-catalogue-toc-link]' +
                '[aria-expanded="true"]'
            );

        if (!openLink) return;

        const openPanel =
            getTableOfContentsPanel(openLink);

        if (!openPanel || openPanel.hidden) {
            return;
        }

        positionResponsiveTableOfContentsPanel(
            openLink,
            openPanel
        );
    };

    let catalogueResizeTimer;

    window.addEventListener('resize', () => {
        window.clearTimeout(catalogueResizeTimer);

        catalogueResizeTimer = window.setTimeout(() => {
            fitCatalogueBookToAvailableHeight();

            if (pageFlip) {
                pageFlip.update();

                window.requestAnimationFrame(() => {
                    syncCatalogueMeasurements();
                    updatePageFlipUi();
                    repositionOpenTableOfContentsPanel();
                });
            } else {
                syncCatalogueMeasurements();
                repositionOpenTableOfContentsPanel();
            }
        }, 150);
    });

    window.addEventListener(
        'scroll',
        repositionOpenTableOfContentsPanel,
        true
    );

    updateInitialSectionLabels();

    initialisePageFlipTest();

    update();
    preloadNextPage();
    buildFullSearchIndex();

    loadCatalogueSparkLayerPrices(track);

    refreshCatalogueCartState();

    /*
     * SparkLayer can update the Shopify cart without reloading
     * the catalogue. Poll only while the page is visible so the
     * product outlines and tooltip quantities remain current.
     */
    window.setInterval(() => {
        if (!document.hidden) {
            refreshCatalogueCartState();
        }
    }, 3000);

    window.addEventListener(
        'pageshow',
        refreshCatalogueCartState
    );

    window.addEventListener(
        'focus',
        refreshCatalogueCartState
    );

    document.addEventListener(
        'visibilitychange',
        () => {
            if (!document.hidden) {
                refreshCatalogueCartState();
            }
        }
    );

});
